import { Injectable } from '@angular/core';
import { IAbstractPresenter } from '@core/interfaces';
import { ISuggestionsComponent, ISuggestionsPresenter } from './interfaces';
import { MenuItem, Price, ProductChannel } from '@/core/models';
import { getPrimaryProductChannel } from '@features/home/util';
import {
  hasSuggestedSingleProductItems,
  homeProcessor,
} from '@features/home/domain';

@Injectable()
export class SuggestionsPresenter
  extends IAbstractPresenter<ISuggestionsComponent>
  implements ISuggestionsPresenter {
  constructor() {
    super();
  }

  dispatchActions(): void { }
  suscribeObservers(): void { }

  productChannel<T extends keyof ProductChannel>(article: MenuItem, key: T): ProductChannel[T] | null {
    const channelProduct = getPrimaryProductChannel(article);
    return channelProduct?.[key] ?? null;
  }

  productChannelPrice<T extends keyof Price>(article: MenuItem, key: T): Price[T] | null {
    const priceList = this.productChannel(article, 'precios');

    const [price] = priceList ?? [];

    return price?.[key] ?? null;
  }

  isSuggestedItemOutOfStock(article: MenuItem): boolean {
    return homeProcessor.getSuggestedProductAvailability({ stock: article.stock }).isOutOfStock;
  }

  hasSuggestionItems(items: MenuItem[] | null): boolean {
    return hasSuggestedSingleProductItems(items);
  }
}
